import React, { useState, useEffect } from "react";
import "./assets/css/App.css";
import Navbar from "./components/Navbar";
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import UserManagement from "./components/Users/UserManagement.js";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import MapNavigator from "./components/MapNavigator";
import RiskPredictor from "./components/RiskPredictor";
import PublicRoute from "./components/PublicRoute";
const Layout = ({ children }) => {
  const location = useLocation();
  const hideNavbar = location.pathname === "/login";
  return (
    <>
      {!hideNavbar && <Navbar />}
      <div className="main">{children}</div>
    </>
  );
};

const App = () => {
  const [authUser, setAuthUser] = useState(null);

  useEffect(() => {
    const email = localStorage.getItem("email");
    const role = localStorage.getItem("role");
    if (email && role) {
      setAuthUser({ email, role });
    }
  }, []);

  const handleLogout = async () => {
    localStorage.clear();
    setAuthUser(null);
  };

  return (
    <div className="app">
      <BrowserRouter
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      >
        <Layout>
          <Routes>
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Navigate to="/ethiopia" replace />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ethiopia"
              element={
                <ProtectedRoute>
                  <RiskPredictor />
                </ProtectedRoute>
              }
            />
            <Route
              path="/user-management"
              element={
                <UserManagement authUser={authUser} onLogout={handleLogout} />
              }
            />
            <Route
              path="/map"
              element={
                <ProtectedRoute>
                  <MapNavigator />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Layout>
      </BrowserRouter>
      <ToastContainer />
    </div>
  );
};

export default App;
